/**
 * Created by pratik.panchal on 18-09-2018.
 */
import { createHashHistory } from "history";

const customHistory = createHashHistory();
export default customHistory;
